export default {
  data() {
    return {
      stepHistory: [],
      browserIndex: 0,
    };
  },
  computed: {
    currentStepHistory() {
      return this.stepHistory[this.stepHistory.length - 1];
    },
    currentStep() {
      return this.$store.state.step.currentStep;
    },
  },
  methods: {
    onStepChanged(event) {
      const { step } = event.detail;

      if (step > this.currentStepHistory) {
        this.browserIndex++;
        history.pushState({ index: this.browserIndex }, '');

        this.stepHistory.push(step);
        return;
      }

      this.stepHistory = this.stepHistory.filter((s) => s <= step);
    },

    onPopState(event) {
      const index = event.state?.index;

      let forward = index >= this.browserIndex;
      if (forward) {
        this.browserIndex++;
        return;
      }

      if (this.stepHistory.length === 1) {
        history.back();
        return;
      }

      this.stepHistory.pop();
      this.$store.commit('step/setStepRaw', this.currentStepHistory);
      this.browserIndex--;
    },
  },

  created() {
    this.stepHistory.push(this.currentStep);

    history.replaceState({ index: this.browserIndex }, '');

    window.addEventListener('step-changed', this.onStepChanged);
    window.addEventListener('popstate', this.onPopState);
  },

  beforeDestroy() {
    window.removeEventListener('step-changed', this.onStepChanged);
    window.removeEventListener('popstate', this.onPopState);
  },
};
